module.exports = __webpack_public_path__ + "img/video.e63bd8e1.svg";